<template>
  <div>
    <b-col md="12">
      <div>
        <b-modal
          :no-close-on-backdrop="true"
          :id="`modal-confirm-print`"
          :title="$t('surgery.print-invoice')"
          ok-only
          :ok-title="$t('common.print')"
          @ok="printInvoice"
        >
          <b-card-text>
            <h5>{{ $t('surgery.print-invoice') }}</h5>
            {{ $t('surgery.print-sure') }}
          </b-card-text>
        </b-modal>
        <b-modal
          :no-close-on-backdrop="true"
          id="add-surgery-invoice-modal"
          :title="$t('hospital.create-surgery-invoice')"
          ok-only
          size="lg"
          :ok-title="$t('common.add')"
          @ok="submitItem"
        >
          <b-card-text>
            <b-row>
              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.general_services_amount')"
                  label-for="general_services_amount"
                >
                  <b-form-input
                    type="number"
                    id="general_services_amount"
                    v-model="EditForm.general_services_amount"
                    :placeholder="$t('surgery.general_services_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.surgeon_amount')"
                  label-for="surgeon_amount"
                >
                  <b-form-input
                    type="number"
                    id="surgeon_amount"
                    v-model="EditForm.surgeon_amount"
                    :placeholder="$t('surgery.surgeon_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.anesthetist_amount')"
                  label-for="anesthetist_amount"
                >
                  <b-form-input
                    type="number"
                    id="anesthetist_amount"
                    v-model="EditForm.anesthetist_amount"
                    :placeholder="$t('surgery.anesthetist_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.nursing_amount')"
                  label-for="nursing_amount"
                >
                  <b-form-input
                    type="number"
                    id="nursing_amount"
                    v-model="EditForm.nursing_amount"
                    :placeholder="$t('surgery.nursing_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.admin_services_amount')"
                  label-for="admin_services_amount"
                >
                  <b-form-input
                    type="number"
                    id="admin_services_amount"
                    v-model="EditForm.admin_services_amount"
                    :placeholder="$t('surgery.admin_services_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.consultation_amount')"
                  label-for="consultation_amount"
                >
                  <b-form-input
                    type="number"
                    id="consultation_amount"
                    v-model="EditForm.consultation_amount"
                    :placeholder="$t('surgery.consultation_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.pre_cpap_amount')"
                  label-for="pre_cpap_amount"
                >
                  <b-form-input
                    type="number"
                    id="pre_cpap_amount"
                    v-model="EditForm.pre_cpap_amount"
                    :placeholder="$t('surgery.pre_cpap_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.pre_incubator_amount')"
                  label-for="pre_incubator_amount"
                >
                  <b-form-input
                    type="number"
                    id="pre_incubator_amount"
                    v-model="EditForm.pre_incubator_amount"
                    :placeholder="$t('surgery.pre_incubator_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.pre_ventameter_amount')"
                  label-for="pre_ventameter_amount"
                >
                  <b-form-input
                    type="number"
                    id="pre_ventameter_amount"
                    v-model="EditForm.pre_ventameter_amount"
                    :placeholder="$t('surgery.pre_ventameter_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  :label="$t('surgery.tissue_transplant_amount')"
                  label-for="tissue_transplant_amount"
                >
                  <b-form-input
                    type="number"
                    id="tissue_transplant_amount"
                    v-model="EditForm.tissue_transplant_amount"
                    :placeholder="$t('surgery.tissue_transplant_amount')"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group :label="$t('common.date')" label-for="date">
                  <datetime
                    input-class="form-control"
                    type="datetime"
                    v-model="date"
                    :disabled="true"
                  >
                  </datetime>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-modal>
        <b-card>
          <div>
            <!-- Data Table  -->
            <div class="d-flex justify-content-between mt-4 mb-2">
              <h2>{{ $t('common.invoices') }}</h2>
              <b-button
                v-if="patientSurgeryId"
                @click="$bvModal.show('add-surgery-invoice-modal')"
                variant="primary"
                class="p-1 mb-1"
              >
                {{ $t('hospital.create-surgery-invoice') }}
              </b-button>
            </div>
            <b-table
              :items="this.invoices.data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(service)="data">
                <span class="text-nowrap"> Opearation </span>
              </template>
              <template #cell(amount)="data">
                <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
              </template>
              <template #cell(status)="data">
                <div>
                  <ChangeInvoiceStatusDropDown
                    name="surgeryInvoice"
                    @onEmit="$emit('onChangeStatus')"
                    endpoint="invoicePatientSergury"
                    :data="data.item"
                  />
                </div>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div
                  v-if="data.item.status === 'approved'"
                  class="text-nowrap d-flex"
                >
                  <b-button
                    @click="showModal(data.item)"
                    variant="outline-primary"
                    size="sm"
                    class="mx-4"
                  >
                    {{ $t('reception.Print Invoice') }}
                  </b-button>
                  <b-button
                    ref="surgeryInvoiceRef"
                    v-print="ServicesInvoiceBtn"
                    variant="outline-primary"
                    size="sm"
                    class="hidden"
                  >
                    {{ $t('reception.Print Invoice') }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getInvoices()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="this.dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </div>
      <ServicesInvoice :patientCard="patientData" :data="this.invoice" />
    </b-col>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BModal,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BBadge,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

const AutoComplete = () => import('@/components/common/AutoComplete.vue');
const ServicesInvoice = () =>
  import('@/components/printables/ServicesInvoice.vue');
const ChangeInvoiceStatusDropDown = () =>
  import('@/components/invoices/ChangeInvoiceStatusDropDown.vue');
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BBadge,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    ToastificationContent,
    Datetime,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    ChangeInvoiceStatusDropDown,
    ServicesInvoice,
  },
  data() {
    return {
      tableColumns: [
        {
          key: 'invoice_no',
          label: this.$t('surgery.invoice_no'),
          sortable: true,
        },

        {
          key: 'room_amount',
          label: this.$t('surgery.room_amount'),
          sortable: true,
        },

        {
          key: 'date',
          sortable: true,
          label: this.$t('common.date'),
        },

        {
          key: 'general_services_amount',
          sortable: true,
          label: this.$t('surgery.general_services_amount'),
        },
        {
          key: 'admin_services_amount',
          sortable: true,
          label: this.$t('surgery.admin_services_amount'),
        },
        {
          key: 'anesthetist_amount',
          sortable: true,
          label: this.$t('surgery.anesthetist_amount'),
        },
        {
          key: 'surgeon_amount',
          sortable: true,
          label: this.$t('surgery.surgeon_amount'),
        },
        {
          key: 'surgeon_assist_amount',
          sortable: true,
          label: this.$t('surgery.surgeon_assist_amount'),
        },
        {
          key: 'surgery_room_amount',
          sortable: true,
          label: this.$t('surgery.surgery_room_amount'),
        },
        {
          key: 'room_amount',
          sortable: true,
          label: this.$t('surgery.room_amount'),
        },
        {
          key: 'consultation_amount',
          sortable: true,
          label: this.$t('surgery.consultation_amount'),
        },
        {
          key: 'labour_room_amount',
          sortable: true,
          label: this.$t('surgery.labour_room_amount'),
        },
        {
          key: 'medical_consumables_amount',
          sortable: true,
          label: this.$t('surgery.medical_consumables_amount'),
        },
        {
          key: 'nursing_amount',
          sortable: true,
          label: this.$t('surgery.nursing_amount'),
        },
        {
          key: 'pre_cpap_amount',
          sortable: true,
          label: this.$t('surgery.pre_cpap_amount'),
        },
        {
          key: 'pre_incubator_amount',
          sortable: true,
          label: this.$t('surgery.pre_incubator_amount'),
        },
        {
          key: 'pre_test_amount',
          sortable: true,
          label: this.$t('surgery.pre_test_amount'),
        },
        {
          key: 'pre_ventameter_amount',
          sortable: true,
          label: this.$t('surgery.pre_ventameter_amount'),
        },
        {
          key: 'tissue_transplant_amount',
          sortable: true,
          label: this.$t('surgery.tissue_transplant_amount'),
        },
        {
          key: 'status',
          sortable: true,
          label: this.$t('common.status'),
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      invoiceLatestStatus: '',
      InvoiceId: '',
      invoice: {},
      ServicesInvoiceBtn: {
        id: 'ServicesInvoice',
      },
      EditForm: {
        patient_card_surgery_id: this.patientSurgeryId,
        general_services_amount: '',
        nursing_amount: '',
        anesthetist_amount: '',
        surgeon_amount: '',
        admin_services_amount: '',
        medical_consumables_amount: 0,
        consultation_amount: '',
        pre_cpap_amount: '',
        pre_incubator_amount: '',
        pre_ventameter_amount: '',
        tissue_transplant_amount: '',

        date: '',
      },
      date: new Date(Date.now()).toISOString(),

      errorForm: {
        patient_card_surgery_id: '',
        general_services_amount: '',
        nursing_amount: '',
        anesthetist_amount: '',
        surgeon_amount: '',
        admin_services_amount: '',
        consultation_amount: '',
        pre_cpap_amount: '',
        pre_incubator_amount: '',
        pre_ventameter_amount: '',
        tissue_transplant_amount: '',
        date: '',
      },
      params: {
        form: {},
        path: '',
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      dataCount: 0,
    };
  },
  props: ['invoices', 'patientData', 'patientSurgeryId', 'getData'],

  mounted() {},
  methods: {
    formatDate(surgeryDate) {
      const date = new Date(surgeryDate);

      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1);
      let day = '' + date.getDate();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    printInvoice() {
      this.$refs.surgeryInvoiceRef.click();
      this.changeStatusToPrinted();
    },
    showModal(status) {
      this.$bvModal.show('modal-confirm-print');
      this.invoice = status;
    },

    changeStatusToPrinted() {
      (this.params.form = { status: 'printed' }),
        (this.params.path = `/invoicePatientSergury/${this.invoice.id}/changeStatus`),
        this.$store
          .dispatch('put', this.params)
          .then((response) => {
            this.getData();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },

    submitItem() {
      this.EditForm.patient_card_surgery_id = this.patientSurgeryId;
      this.EditForm.date = this.formatDate(this.date);
      (this.params.form = this.EditForm),
        (this.params.path = `invoicePatientSergury`),
        this.$store
          .dispatch('create', this.params)
          .then(async (response) => {
            this.getData();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${this.$t('common.success')}`,
                variant: 'success',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
